import React from "react";

export const HeaderContext = React.createContext({
    parent: null,
    goToMyPlan: null,
    logout: null,
    me: null,
    isAdmin: null,
    fidelity: [],
});